// extracted by css-extract-rspack-plugin
export default {"root":"IDWexe","icon":"jps2VB","tooltip":"SPbbq9"};